import { SearchInput } from "./SearchInput";
import { useNavigate } from "react-router-dom";
import { isWellFormattedAddress } from "../lib/api";

/**
 * Template component that initializes the "User Search" panel to include a
 * wallet icons and search input field that validates arweave addresses and
 * redirects to the appropriate `/users/{address}` route to display the results
 * when the user clicks the "Search" button in the <SearchInput /> component.
 */
export const UserSearch = (props) => {
  const navigate = useNavigate();
  const onUserSearch = (address) => {
    navigate(`/creators/${address}`);
  };
  const walletIcon = (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 359 318"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      fill="currentColor"
    >
      <g transform="matrix(1,0,0,1,-171,-123)">
        <path
          d="M479.36,430.86C490.798,430.86 501.766,426.317 509.852,418.231C517.938,410.145 522.481,399.176 522.481,387.739L522.481,264.539C522.481,250.816 517.028,237.656 507.325,227.953C497.622,218.246 484.462,212.797 470.735,212.797L236.545,212.797C230.193,212.801 224.088,210.34 219.51,205.93C214.936,201.524 212.252,195.512 212.018,189.164C212.248,182.386 215.073,175.957 219.908,171.203C224.744,166.453 231.22,163.738 238.002,163.629L470.732,163.629C475.307,163.629 479.697,165.445 482.931,168.679C486.166,171.914 487.982,176.301 487.982,180.874L487.982,186.699C487.982,192.863 491.267,198.554 496.607,201.637C501.943,204.719 508.517,204.719 513.853,201.637C519.189,198.555 522.478,192.863 522.478,186.699L522.478,180.874C522.478,167.151 517.025,153.991 507.322,144.288C497.619,134.581 484.459,129.132 470.732,129.132L236.542,129.132C220.897,129.16 205.901,135.39 194.839,146.452C183.777,157.515 177.55,172.511 177.519,188.155L177.519,361.865C177.519,380.162 184.789,397.713 197.726,410.65C210.664,423.587 228.214,430.857 246.511,430.857L479.36,430.86ZM487.985,333.083L428.399,333.087C423.665,333.024 419.837,329.2 419.778,324.462L419.778,314.38C419.778,309.618 423.637,305.759 428.399,305.759L488.094,305.759L487.985,333.083ZM212.015,361.868L212.015,241.918C219.699,245.484 228.074,247.32 236.542,247.293L470.732,247.293C475.306,247.293 479.697,249.109 482.931,252.344C486.165,255.578 487.982,259.965 487.982,264.539L487.982,271.148L428.396,271.148C416.951,271.179 405.982,275.746 397.9,283.851C389.818,291.953 385.279,302.933 385.279,314.378L385.279,324.796C385.396,336.163 389.986,347.03 398.056,355.038C406.126,363.046 417.029,367.55 428.396,367.581L488.091,367.581L488.091,387.741L488.095,387.737C488.095,392.503 484.231,396.362 479.47,396.362L246.51,396.362C237.361,396.362 228.588,392.729 222.119,386.26C215.646,379.791 212.014,371.014 212.014,361.865L212.015,361.868Z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
  return (
    <SearchInput
      icon={walletIcon}
      prompt="enter wallet address"
      searchInput={props.searchInput ? props.searchInput : ""}
      isInputValid={isWellFormattedAddress}
      onSearch={onUserSearch}
    />
  );
};
